import CryptoJS from 'crypto-js';

// Encrypted offline codes (generated with AES CBC)
const ENCRYPTED_CODES = [
    '8TwU/0D6/P8bCkwu97Er6S9Z3mIuJ+WA/MxwIBLoKIc=',
    'ZgkT6n5AHBpLREyOPqx9w4cPdC9WcWsOss9U7ou8b1E=',
    'LsCJMzxfi4PXkMANWh6zCIzP1crHKRKMGF9lDCb1VE4=',
    'pT369D+j257u2SdcNtjiIvfHOz5idihEioMfFnvT92g=',
    'G2hxw0A4rkwqekjPQlSCgyX35IHUpgqaJPpvbBA95T4='
];

const KEY = CryptoJS.enc.Utf8.parse('wfm_offline_key_');
const IV = CryptoJS.enc.Utf8.parse('wfm_offline_iv_1');

/**
 * Decrypts the stored offline codes.
 * @returns {string[]} Array of plain-text offline codes.
 */
export const getDecryptedCodes = () => {
    return ENCRYPTED_CODES.map(ciphertext => {
        try {
            const bytes = CryptoJS.AES.decrypt(ciphertext, KEY, {
                iv: IV,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            return bytes.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.error("Decryption failed for code:", ciphertext, e);
            return null;
        }
    }).filter(code => code !== null);
};

/**
 * Verifies if the entered code is one of the valid offline codes.
 * @param {string} inputCode The code entered by the user.
 * @returns {boolean} True if valid, false otherwise.
 */
export const verifyOfflineCode = (inputCode) => {
    if (!inputCode) return false;
    const codes = getDecryptedCodes();
    return codes.includes(inputCode.trim());
};
